import {View} from 'react-native';
import * as React from 'react';
import {useStyles} from '../../../hooks/styles';
import {SocialSupportTableProps} from '../model';
import {Text} from '../../text';
import {CustomScrollView} from '../../scrollView';
import {useDimensions} from '../../../hooks/useDimensions';

const minColumnWidth = 200;

export default ({columns, data}: SocialSupportTableProps) => {
  const windowDimensions = useDimensions();
  const styles = useStyles(({theme}) => ({
    scrollView: {
      width: '100%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderColor: theme.color.borderColor,
      borderBottomWidth: 0,
    },
    scrollContainer: {
      width: '100%',
      minWidth: columns.reduce((prev, cur) => prev + (cur.size ?? 1), 0) * minColumnWidth,
    },
    contentWrapper: {flex: 1, position: 'relative', paddingTop: 65},
    scrollContentWrapper: {flex: 1, maxHeight: (windowDimensions.height / 3) * 2, overflow: 'scroll'},
    rowHead: {flexDirection: 'row', position: 'absolute', minHeight: 65, top: 0, right: 0, left: 0},
    col: {
      flex: 1,
      paddingLeft: 16,
      paddingRight: 4,
      paddingTop: 12,
      paddingBottom: 12,
    },
    colHead: {
      borderStyle: 'solid',
      borderBottomColor: theme.color.borderColor,
      borderBottomWidth: 1,
      justifyContent: 'center',
    },
    rowBody: {flexDirection: 'row'},
    colBody: {
      borderStyle: 'solid',
      borderBottomColor: theme.color.borderColor,
      borderBottomWidth: 1,
    },
    colTextHead: {
      ...theme.fonts.bodySmallLight,
      color: theme.color.labelText,
    },
    colTextBody: {
      ...theme.fonts.body,
    },
  }));
  return (
    <CustomScrollView
      nestedScrollEnabled={true}
      horizontal={true}
      style={styles.scrollView}
      contentContainerStyle={[styles.scrollContainer]}>
      <View style={styles.contentWrapper}>
        <View style={styles.rowHead}>
          {columns.map((column, i) => (
            <View key={i} style={[styles.col, styles.colHead, {flex: column.size ?? 1}]}>
              <Text numberOfLines={2} style={styles.colTextHead}>
                {column.title}
              </Text>
            </View>
          ))}
        </View>
        <CustomScrollView
          withRefresh={false}
          nestedScrollEnabled={true}
          style={styles.scrollContentWrapper}
          horizontal={false}>
          {data.map((row, i) => (
            <View key={i} style={styles.rowBody}>
              {columns.map((column, i2) => {
                return (
                  <View key={i2} style={[styles.col, styles.colBody, {flex: column.size ?? 1}]}>
                    <Text style={styles.colTextBody}>{row[column.field]}</Text>
                  </View>
                );
              })}
            </View>
          ))}
        </CustomScrollView>
      </View>
    </CustomScrollView>
  );
};
